import { AppUpdate } from '@/types/updates';

export const update_2026_03: AppUpdate = {
  id: 'visual-depth-2026-03',
  slug: 'parallax-background-engine-expansion',
  title: 'Visual Depth: The 150+ Parallax Effect Library',
  description: 'April was a feast for the eyes. We introduced the Parallax Visual Engine, allowing for deep, multilayered environments that move with your imagination.',
  date: 'April 12, 2026',
  timestamp: 1776067200,
  category: 'FEATURE',
  version: '0.9.0',
  readTime: '6 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'Painting Beyond the Canvas'
    },
    {
      type: 'text',
      content: 'We believe that the environment is just as important as the physics. In April, we moved away from simple backgrounds to a sophisticated Parallax Engine. This system allows us to layer multiple effects on top of each other, creating a sense of 3D depth in a 2D digital space.'
    },
    {
      type: 'heading',
      content: '150+ New Effects Across 10 Categories'
    },
    {
      type: 'text',
      content: 'This update wasn\'t just a small addition; it was a library expansion. We added over 150 unique effects categorized to help creators find the right "vibe" for their music.'
    },
    {
      type: 'list',
      content: [
        'Astral & Cosmic: Nebula Drifts, Black Hole Singularities, and Starry Night patterns.',
        'Cybernetic & Tech: Matrix Rain, Circuit Boards, and Terminal Stream overlays.',
        'Bio-Organic: DNA Helixes, Neural Networks, and Spore Drifts.',
        'Geometric & Brutalist: Isometric Cubes, Brutalist Blocks, and Minimalist Lines.',
        'Artistic & Sketch: Watercolor Bleeds, Charcoal Sketches, and Ink Bleed patterns.'
      ]
    },
    {
      type: 'heading',
      content: 'Interactivity: Backgrounds that React'
    },
    {
      type: 'text',
      content: 'The new Parallax system isn\'t static. These background layers can be mapped to the simulation\'s energy. For example, in Rhythmic Mode, the "Aurora Borealis" effect can pulse in intensity with the bass drum, while "Matrix Rain" can speed up based on the total velocity of the balls on screen.'
    },
    {
      type: 'highlight',
      content: '"Depth isn\'t just about perspective; it\'s about immersion. By adding layers of movement behind the physics, we make the digital world feel like a living, breathing space."'
    },
    {
      type: 'heading',
      content: 'Global Visuals & Layer Sorting'
    },
    {
      type: 'text',
      content: 'To manage this new complexity, we added the "Global Visuals" section to the settings panel. You can now choose what appears in front of the balls (Overlays) and what stays behind them (Backgrounds), adjusting the opacity and blur of every single layer individually.'
    },
    {
      type: 'heading',
      content: 'The "VHS" and "Retro" Pack'
    },
    {
      type: 'text',
      content: 'As a special addition for social media creators, we introduced a suite of post-processing filters including VHS Glitch, Scanlines, and Analog Noise. These effects give your simulations a distinct character that feels authentic and high-quality.'
    }
  ]
};
